import InsurancePanel from './InsurancePanel';

export default InsurancePanel;
